<template>
  <form @submit.prevent="applyFilter">
    <v-row v-if="moduleType === 'bomConfig'">
      <v-col cols="12" md="3" lg="3" sm="4" xs="12">
        <label class="font-weight-medium body-2"> Status </label>
        <v-autocomplete clearable :items="statusArray" v-model="selectStatus" item-text="text" item-value="value"
          placeholder="--Select Status--" hide-details />
      </v-col>
      <v-col cols="12" md="3" lg="3" sm="4" xs="12">
        <label class="font-weight-medium body-2"> Model </label>
        <v-autocomplete clearable :items="modelArray" v-model="selectModel" item-text="title" item-value="id"
          placeholder="--Select Model--" hide-details />
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.xs" cols="12" md="3" lg="3" sm="12">
        <v-card-actions class="justify-center">
          <v-btn color="#5d58ef" class="white--text" small dense type="submit">
            <v-icon left>mdi-filter</v-icon>Apply
          </v-btn>
          <v-btn class="ml-5" @click="resetApplyFilter" depressed dense small>
            <v-icon left> mdi-restart</v-icon> Reset
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col v-else cols="12" xs="12" class="px-0">
        <v-row no-gutters>
          <v-col class="mb-2" cols="12" xs="12">
            <v-btn color="#5d58ef" class="white--text" dense style="min-width: 100%" type="submit">
              <v-icon left>mdi-filter</v-icon>Apply
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12">
            <v-btn depressed dense style="min-width: 100%" @click="resetApplyFilter">
              <v-icon left> mdi-restart</v-icon> Reset
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="moduleType === 'kitOrdering'">
      <v-col cols="12" md="3" lg="3" sm="4" xs="12">
        <label class="font-weight-medium body-2"> Approval Status </label>
        <v-autocomplete clearable :items="approvalStatusArray" v-model="selectApprovalStatus"
          placeholder="--Select Approval Status--" hide-details />
      </v-col>
      <v-col cols="12" md="3" lg="3" sm="4" xs="12">
        <label class="font-weight-medium body-2"> Center </label>
        <v-autocomplete clearable :items="centerArray" item-text="companyName" item-value="id" v-model="selectCenter"
          placeholder="--Select Center--" hide-details />
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.xs" cols="12" md="3" lg="3" sm="12">
        <v-card-actions class="justify-center">
          <v-btn color="#5d58ef" class="white--text" small dense type="submit">
            <v-icon left>mdi-filter</v-icon>Apply
          </v-btn>
          <v-btn class="md-5" @click="resetApplyFilter" depressed dense small>
            <v-icon left> mdi-restart</v-icon> Reset
          </v-btn>
        </v-card-actions>
      </v-col>
      <v-col v-else cols="12" xs="12" class="px-0">
        <v-row no-gutters>
          <v-col class="mb-2" cols="12" xs="12">
            <v-btn color="#5d58ef" class="white--text" dense style="min-width: 100%" type="submit">
              <v-icon left>mdi-filter</v-icon>Apply
            </v-btn>
          </v-col>
          <v-col cols="12" xs="12">
            <v-btn depressed dense style="min-width: 100%" @click="resetApplyFilter">
              <v-icon left> mdi-restart</v-icon> Reset
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>
<script>
import Utils from '@/utils'
import moment from 'moment'
import CONSTANTS from '@/utils/constants'
export default {
  name: 'filterComponent',
  props: {
    moduleType: {
      type: String,
      default: 'bomConfig'
    },
    modelArray: {
      type: Array,
      default: () => []
    },
    centerArray: {
      type: Array,
      default: () => []
    },
    C1_APPROVED: {
      type: Boolean,
      default: false
    },
    C2_APPROVED: {
      type: Boolean,
      default: false
    },
    C3_APPROVED: {
      type: Boolean,
      default: false
    },
    initiateOrderListAPI: {
      type: Boolean,
      default: false
    },
    configurationDialog: {
      type: Boolean,
      default: false
    },
    viewDetailsDialog: {
      type: Boolean,
      default: false
    },
    isSuperAdmin: {
      type: Boolean,
      default: false
    },
    WOWKIT_ZSM_APPROVED: {
      type: Boolean,
      default: false
    },
    WOWKIT_APPROVED: {
      type: Boolean,
      default: false
    },
    reloadFlag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectStatus: CONSTANTS.WOW_KIT_STATUS.pending,
      selectModel: null,
      selectApprovalStatus: '',
      selectCenter: null,
      WOWKIT_MAKER: this.checkModuleAccess('WOW_KIT_MAKER')
    }
  },
  computed: {
    statusArray: function () {
      return CONSTANTS.WOW_KIT_BOM_CONFIGURATION_STATUS_LIST
    },
    approvalStatusArray: function () {
      return CONSTANTS.WOW_KIT_APPROVER_STATUS_LIST
    }
  },
  watch: {
    C1_APPROVED: function (newVal, oldVal) {
      if (newVal) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.pending
      }
    },
    C2_APPROVED: function (newVal, oldVal) {
      if (newVal) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c1Approved
      }
    },
    C3_APPROVED: function (newVal, oldVal) {
      if (newVal) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c2Approved
      }
    },
    WOWKIT_ZSM_APPROVED: function (newVal, oldVal) {
      if (newVal) {
        this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.pending
      }
    },
    WOWKIT_APPROVED: function (newVal, oldVal) {
      if (newVal) {
        this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.zmApprove
      }
    },
    initiateOrderListAPI: async function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        await this.getInitiatedOrderList()
      }
    },
    configurationDialog: async function (newVal, oldVal) {
      if (newVal !== oldVal && !newVal) {
        if (this.moduleType === 'bomConfig') {
          await this.getWowBomConfigurationLit()
        } else {
          await this.getInitiatedOrderList()
        }
      }
    },
    viewDetailsDialog: async function (newVal, oldVal) {
      if (newVal !== oldVal && !newVal) {
        if (this.moduleType === 'bomConfig') {
          await this.getWowBomConfigurationLit()
        } else {
          await this.getInitiatedOrderList()
        }
      }
    },
    reloadFlag: async function (newVal, oldVal) {
      if (newVal !== oldVal && newVal) {
        if (this.moduleType === 'bomConfig') {
          await this.getWowBomConfigurationLit()
        } else {
          await this.getInitiatedOrderList()
        }
      }
    }
  },
  async created () {
    if (this.moduleType === 'bomConfig') {
      if (this.C1_APPROVED) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.pending
      } else if (this.C2_APPROVED) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c1Approved
      } else if (this.C3_APPROVED) {
        this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c2Approved
      }
      if (this.WOWKIT_MAKER) {
        this.selectStatus = ''
      }
      await this.getWowBomConfigurationLit()
    } else {
      if (this.WOWKIT_ZSM_APPROVED) {
        this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.pending
      }
      if (this.WOWKIT_APPROVED) {
        this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.zmApprove
      }
      await this.getInitiatedOrderList()
    }
  },
  methods: {
    getWowBomConfigurationLit: async function () {
      try {
        let queryString = ''
        if (this.selectModel && this.selectStatus) {
          queryString += `?model=${this.selectModel}&status=${this.selectStatus}`
        } else if (this.selectStatus) {
          queryString += `?status=${this.selectStatus}`
        } else if (this.selectModel) {
          queryString += `?model=${this.selectModel}`
        }
        let res = await http.get(`${CONSTANTS.API_URL}/api/wow-kit/configuration-list${queryString}`)
        if (res.status === 200) {
          res.data.forEach(item => {
            item.createdAt = item.createdAt ? moment(new Date(item.createdAt)).format('DD MMM YYYY') : '-'
          })
          this.$emit('setBomConfigurationList', res.data)
        } else {
          this.errMsg(res.data.message)
        }
      } catch (e) {
        const errMsg = e.response.data.message || e.response.message
        this.errMsg(errMsg)
      }
    },
    getInitiatedOrderList: async function () {
      try {
        let payload = {}
        if (this.selectApprovalStatus) {
          payload.approvalStatus = this.selectApprovalStatus
        }
        if (this.selectCenter) {
          payload.centerID = this.selectCenter
        }
        const res = await http.post(`${CONSTANTS.API_URL}/api/wow-kit/initiateorderdetailslist`, payload)
        if (res.status === 200) {
          res.data.forEach(item => {
            item.createdAt = item.createdAt ? moment(new Date(item.createdAt)).format('DD MMM YYYY') : '-'
          })
          this.$emit('setInitiatedOrderDetails', res.data)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    applyFilter: async function () {
      if (this.moduleType === 'bomConfig') {
        await this.getWowBomConfigurationLit()
      } else {
        await this.getInitiatedOrderList()
      }
    },
    resetApplyFilter: function () {
      this.selectModel = null
      this.selectStatus = ''
      this.selectApprovalStatus = ''
      if (this.moduleType === 'bomConfig') {
        if (this.C1_APPROVED) {
          this.selectStatus = CONSTANTS.WOW_KIT_STATUS.pending
        } else if (this.C2_APPROVED) {
          this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c1Approved
        } else if (this.C3_APPROVED) {
          this.selectStatus = CONSTANTS.WOW_KIT_STATUS.c2Approved
        }
      } else {
        if (this.WOWKIT_ZSM_APPROVED) {
          this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.pending
        }
        if (this.WOWKIT_APPROVED) {
          this.selectApprovalStatus = CONSTANTS.WOW_KIT_APPROVER.zmApprove
        }
      }
      this.selectCenter = null
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
